import { useAuth } from "@babackapp/auth-client/hooks";
import {
  hasActiveSuperpower,
  isSuperpowerAwaitingMfa,
} from "@babackapp/auth-client/utils";
import { useCurrentUser } from "@babackapp/private-api-client/client/use-current-user";

// `GET /users/me` is refetched when MFA changes; the login user is only the
// fallback until it loads, so enabling MFA takes effect without a reload.
// Never stale otherwise: mounted on every page (banner), it would refetch on
// each window focus, and only the MFA mutations change what is read here.
function useViewer() {
  const { user } = useAuth();
  const { data: currentUser } = useCurrentUser({ staleTime: Infinity });
  return currentUser ?? user;
}

/**
 * Returns true if the current viewer has super admin powers: the
 * services.superpowers.activated flag on their user record, and MFA enabled.
 */
export function useViewerIsSuperAdmin(): boolean {
  return hasActiveSuperpower(useViewer());
}

/** Flagged as super admin, but powers stay off until MFA is enabled. */
export function useViewerSuperpowerAwaitsMfa(): boolean {
  return isSuperpowerAwaitingMfa(useViewer());
}

/** @deprecated Use `useViewerIsSuperAdmin` instead. */
export const useViewerIsBabackTeam = useViewerIsSuperAdmin;
